module.exports = __webpack_public_path__ + "static/media/nd2.d669e690.jpg";